// extracted by mini-css-extract-plugin
module.exports = {"nav_bar":"styles_nav_bar__1MALZ","back_icon":"styles_back_icon__116ia"};